import React, { Component } from 'react';
import { Link } from 'react-router';
import { isMobile } from 'helpers/ApplicationHelper';
import  { rootUrl } from 'helpers/ApplicationHelper'

class LogosFooter extends Component{
    constructor(props){
        super(props);
    }

    render(){
        return(
            <div className="compamies">
            {
                !isMobile() ?
                    <div>
                        <Link to="http://www.symantec.com/" className="norton" target="_blank"></Link>
                        <Link to="http://www.lloyds.com/" className="lloyds" target="_blank"></Link>
                        <Link to="http://www.bbb.org/new-york-city/business-reviews/online-retailer/worthy-com-in-new-york-ny-149680" className="bbb" target="_blank"></Link>
                        <Link to="http://www.gia.edu/gia-about-mission-governance/" className="gia" target="_blank"></Link>
                        <Link to="http://www1.nyc.gov/site/dca/index.page" className="nyc" target="_blank"></Link>
                        <Link to="http://www.jewelersforchildren.org/" className="jfc" target="_blank"></Link>
                        <Link to="http://www.brinks.com/" className="brinks" target="_blank"></Link>
                    </div>
                : <div>
                    <div className="row">
                        <Link to={rootUrl('/about/certifications-licenses')} className='insured' target="_blank" rel='nofollow'></Link>
                        <Link to="http://www.bbb.org/new-york-city/business-reviews/online-retailer/worthy-com-in-new-york-ny-149680" className='bbb' target="_blank" rel='nofollow'></Link>
                        <Link to="http://www.brinks.com/" className='brinks' target="_blank" rel='nofollow'></Link>
                    </div>
                    <div className="row">
                        <Link to="http://www.gia.edu/gia-about-mission-governance" className='gia' target="_blank" rel='nofollow'></Link>
                        <Link to="https://www.paypal.com/us/webapps/mpp/home" className='paypal' target="_blank" rel='nofollow'></Link>
                        <Link to="http://www.lloyds.com" className='lloyds' target="_blank" rel='nofollow'></Link>
                    </div>
                </div>
            }
            </div>
        )
    }
}

export default LogosFooter;
